<template>
    <div class="col-12 pt-3">
        <transition name="fade" mode="out-in">
            <ContentOrLoading>
                <template v-if="evento">
                    
                    <FormComponent :evento="evento" :key="reload" @actualizado="actualizar" />
                    <div class="row">
                        <div class="col-12">
                            <hr/>
                        </div>
                    </div>

                    <UserViewerComponent :evento="evento" @actualizar="actualizar" /> 
                    
                </template>                    
            </ContentOrLoading>
        </transition>
    </div>
</template>

<script>
    import ContentOrLoading from "@/components/backend/components/ContentOrLoading";
    import FormComponent from '@/components/backend/eventos/compania/FormComponent';
    import UserViewerComponent from '@/components/backend/eventos/compania/UserViewerComponent';

    export default {
        props: ['evento'],
        data() {
            return {
                email: '',
                reload: 1
            }
        },
        methods: {
            actualizar() {
                this.$emit('actualizar')
                reload++
            }
        },
        components: {
            ContentOrLoading, FormComponent, UserViewerComponent
        }
    }
</script>
